export enum UploadSessionStatus {
  Created = 'created',
  Completed = 'completed',
  Aborted = 'aborted',
  Expired = 'expired',
}
